import React from 'react';
import PaperClip from './PaperClip';
import TapeStrip from './TapeStrip';
import SectionCourier from './SectionCourier';
import portrait from '../assets/Portrait.png';
import './HeroPortrait.css';

/*
 * HeroPortrait
 * The hero photograph in a warm paper frame with one restrained tape strip and
 * one paperclip. The full, uncropped portrait is shown (width:100% / height
 * auto, i.e. contain) so the professional full-length composition and the
 * background stay visible. No text, tag or label sits over the image — a small
 * caption sits beneath it, and the courier perches just outside the frame's
 * top-left corner — the end of the hero's Delivered Letter Trail.
 * Decorative marks are aria-hidden; the photo carries real alt text.
 */
function HeroPortrait() {
  return (
    <figure className="hero-figure">
      <div className="hero-figure-frame">
        <TapeStrip className="hero-figure-tape" tone="cream" />
        <PaperClip className="hero-figure-clip" width={26} />
        <img
          className="hero-figure-img"
          src={portrait}
          alt="Adiba Akter, a software engineer, in a full-length professional portrait"
          width="928"
          height="1394"
        />
      </div>

      <figcaption className="hero-figure-caption">
        Adiba Akter <span aria-hidden="true">·</span> Software Engineer
      </figcaption>

      <SectionCourier
        className="hero-figure-bird"
        /* empty-clawed: the letter it was carrying is the one that just
           arrived at its feet along the Delivered Letter Trail */
        carry="none"
        width={64}
        from={{ x: -20, y: 10, rotate: -14 }}
        restRotate={-5}
        delay={0.15}
      />
    </figure>
  );
}

export default HeroPortrait;
